<template>
  <div id="app">
    <div class="login_box_all loginbox">
      <div class="login_box_content">
        <div class="login_titleBox">
          <!-- <div class="login_logo hidden-sm-and-down"></div> -->
          <div class="text-center login_title">
            <img src="../../assets/images/login_logo.png" />
            《{{ $store.state.Name }}》{{ titlea }} —
            <span class="highorange">{{ title }}</span>
          </div>
        </div>
        <div class="login_maxBox">
          <div class="container login_box">
            <el-tabs
              v-model="activeName"
              @tab-click="handleClick"
              class="loginList"
            >
              <el-tab-pane label="UserName" name="first" class="ten">
                <el-form
                  ref="form"
                  :model="form"
                  label-width="100px"
                  class="twenfive"
                >
                  <div v-if="status != 1">
                    <el-form-item label="UserName:">
                      <el-col>
                        <el-input
                          v-model="form.user"
                          placeholder="Please input Username"
                          @input="oninput()"
                        ></el-input>
                        <div class="msg_error" v-show="userhid">
                          {{ userhid }}
                        </div>
                        <div style="display: none" class="msg_error">
                          Please input Username
                        </div>
                      </el-col>
                    </el-form-item>
                    <el-form-item label="Password:">
                      <el-col>
                        <el-input
                          v-model="form.pass"
                          placeholder="Please input Password"
                          show-password
                          @blur="DetectInput($event, 'pws')"
                        ></el-input>
                      </el-col>
                      <div class="msg_error" v-show="passhid">
                        {{ passhid }}
                      </div>
                      <div class="clearfix"></div>
                      <div
                        class="five five msg_error"
                        style="zoom: normal"
                        v-if="pwdErr"
                      >
                        <span
                          >Your password does not meet relevant
                          requirements,Please &nbsp;<router-link
                            to="/ChangePassword"
                            style="color: #428bca"
                            >click here</router-link
                          >&nbsp;to change your password.</span
                        >
                      </div>
                    </el-form-item>
                    <el-form-item label="V Code:">
                      <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.yzcode"
                          placeholder="Please input V code"
                          @keyup.enter="Login(1)"
                        ></el-input>
                      </el-col>
                      <el-col
                        :xs="8"
                        :sm="8"
                        :md="8"
                        :lg="8"
                        :xl="8"
                        class="ml15"
                      >
                        <span style="cursor: pointer">
                          <div
                            style="
                              height: 40px;
                              width: 110px;
                              font-size: 22px;
                              padding: 5px;
                            "
                            @click="initVeri()"
                            :style="'background-image:url(' + codeImg + ')'"
                            v-html="Picture"
                          ></div>
                        </span>
                      </el-col>
                      <div class="clearfix"></div>
                      <div class="msg_error" style="width: 100%" v-show="yzhid">
                        {{ yzhid }}
                      </div>
                    </el-form-item>
                    <el-form-item label class="loginbtn" v-if="!isLoginCode">
                      <el-button type="primary" @click="Login(1)"
                        >Login</el-button
                      >
                    </el-form-item>
                    <el-form-item label class="loginbtn" v-else>
                      <el-button type="primary" @click="Login(1, 1)"
                        >Login</el-button
                      >
                    </el-form-item>
                  </div>
                  <template v-if="status == 1 && isLoginCode">
                    <div class="twenfive" style="margin-top: 0px">
                      <div class="highgreen">
                        The system has sent the verification code to{{
                          mobelEm
                        }},please find.
                      </div>
                    </div>
                    <el-form-item
                      label="Email V Code:"
                      :rules="[{ required: true }]"
                      style="margin-top: 15px"
                    >
                      <el-col :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.yzcodes"
                          placeholder="Please input Email V Code"
                        ></el-input>
                      </el-col>
                      <div class="clearfix"></div>
                      <div class="msg_error" v-html="yzcodesTiShi"></div>
                    </el-form-item>
                    <el-form-item label="">
                      <el-button
                        style="width: 48%"
                        type="primary"
                        @click="Login(1, 2)"
                        >Submit</el-button
                      >
                      <el-button
                        style="width: 48%"
                        class="ml1"
                        @click="$router.push('/')"
                        >Cancel</el-button
                      >
                    </el-form-item>
                  </template>
                  <el-form-item label class="login-check">
                    <div class="leftfloat login_pwd" style="margin-left: 3px">
                      <el-checkbox v-model="checked"
                        >Remember password</el-checkbox
                      >
                    </div>
                    <div class="rightfloat">
                      <a
                        class="highblue"
                        @click="$router.push('/LookforPassword')"
                        style="cursor: pointer"
                        >Retrieve password</a
                      >
                    </div>
                  </el-form-item>
                </el-form>
                <div class="clearfix"></div>
              </el-tab-pane>

              <el-tab-pane label="Email" name="second" class="ten">
                <el-form
                  ref="form"
                  :model="form"
                  label-width="100px"
                  class="twenfive"
                >
                  <div v-if="status != 1">
                    <el-form-item label="Email:">
                      <el-col>
                        <el-input
                          v-model="form.user"
                          placeholder="Please input Email"
                          @input="oninput"
                        ></el-input>
                        <div class="msg_error" v-show="userhid">
                          {{ userhid }}
                        </div>
                        <div style="display: none" class="msg_error">
                          Please input Email
                        </div>
                      </el-col>
                    </el-form-item>
                    <el-form-item label="Password:">
                      <el-col>
                        <el-input
                          v-model="form.pass"
                          placeholder="Please input Password"
                          show-password
                          @blur="DetectInput($event, 'pws')"
                        ></el-input>
                      </el-col>
                      <div class="msg_error" v-show="passhid">
                        {{ passhid }}
                      </div>
                      <div class="clearfix"></div>

                      <div
                        class="five five msg_error"
                        style="zoom: normal"
                        v-if="pwdErr"
                      >
                        <span
                          >Your password does not meet relevant
                          requirements,Please &nbsp;<router-link
                            to="/ChangePassword"
                            style="color: #428bca"
                            >click here</router-link
                          >&nbsp;to change your password.</span
                        >
                      </div>
                    </el-form-item>
                    <el-form-item label="V Code:">
                      <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.yzcode"
                          placeholder=" Please input V Code"
                          @keyup.enter="Login(2)"
                        ></el-input>
                      </el-col>
                      <el-col
                        :xs="8"
                        :sm="8"
                        :md="8"
                        :lg="8"
                        :xl="8"
                        class="ml15"
                      >
                        <span style="cursor: pointer">
                          <div
                            style="
                              height: 40px;
                              width: 110px;
                              font-size: 22px;
                              padding: 5px;
                            "
                            @click="initVeri()"
                            :style="'background-image:url(' + codeImg + ')'"
                            v-html="Picture"
                          ></div>
                        </span>
                      </el-col>
                      <div class="msg_error" style="width: 100%" v-show="yzhid">
                        {{ yzhid }}
                      </div>
                    </el-form-item>

                    <el-form-item label class="loginbtn" v-if="!isLoginCode">
                      <el-button type="primary" @click="Login(2)"
                        >Login</el-button
                      >
                    </el-form-item>
                    <el-form-item label class="loginbtn" v-else>
                      <el-button type="primary" @click="Login(2, 1)"
                        >Login</el-button
                      >
                    </el-form-item>
                  </div>
                  <template v-if="status == 1 && isLoginCode">
                    <div class="twenfive" style="margin-top: 0px">
                      <div class="highgreen">
                        The system has sent the verification code to{{
                          mobelEm
                        }},please find.
                      </div>
                    </div>
                    <el-form-item
                      label="Email V Code:"
                      :rules="[{ required: true }]"
                      style="margin-top: 15px"
                    >
                      <el-col :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.yzcodes"
                          placeholder="Please input Email V Code"
                        ></el-input>
                      </el-col>
                      <div class="clearfix"></div>
                      <div class="msg_error" v-html="yzcodesTiShi"></div>
                    </el-form-item>
                    <el-form-item label="">
                      <el-button
                        style="width: 48%"
                        type="primary"
                        @click="Login(1, 2)"
                        >Submit</el-button
                      >
                      <el-button
                        style="width: 48%"
                        class="ml1"
                        @click="$router.push('/')"
                        >Cancel</el-button
                      >
                    </el-form-item>
                  </template>
                  <el-form-item label class="login-check">
                    <div class="leftfloat login_pwd" style="margin-left: 3px">
                      <el-checkbox v-model="checked"
                        >Remember password</el-checkbox
                      >
                    </div>
                    <div class="rightfloat">
                      <a
                        class="highblue"
                        @click="$router.push('/LookforPassword')"
                        style="cursor: pointer"
                        >Retrieve password</a
                      >
                    </div>
                  </el-form-item>
                </el-form>
                <div class="clearfix"></div>
              </el-tab-pane>

              <el-tab-pane
                label="Mobile"
                name="third"
                class="ten"
                v-if="isphones"
              >
                <el-form
                  ref="form"
                  :model="form"
                  label-width="100px"
                  class="twenfive"
                >
                  <div v-if="status != 1">
                    <el-form-item label="Mobile:">
                      <el-col>
                        <el-input
                          v-model="form.user"
                          placeholder="Please input Mobile"
                          @input="oninput"
                        ></el-input>
                        <div class="msg_error" v-show="userhid">
                          {{ userhid }}
                        </div>
                        <div style="display: none" class="msg_error">
                          Please input Mobile
                        </div>
                      </el-col>
                    </el-form-item>
                    <el-form-item label="Password:">
                      <el-col>
                        <el-input
                          v-model="form.pass"
                          placeholder="Please input Password"
                          show-password
                          @blur="DetectInput($event, 'pws')"
                        ></el-input>
                      </el-col>
                      <div class="msg_error" v-show="passhid">
                        {{ passhid }}
                      </div>
                      <div class="clearfix"></div>
                      <div
                        class="five five msg_error"
                        style="zoom: normal"
                        v-if="pwdErr"
                      >
                        <span
                          >Your password does not meet relevant
                          requirements,Please&nbsp;<router-link
                            to="/ChangePassword"
                            style="color: #428bca"
                            >click here</router-link
                          >&nbsp;to change your password.</span
                        >
                      </div>
                    </el-form-item>
                    <el-form-item label="V Code:">
                      <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.yzcode"
                          placeholder="Please input V Code"
                          @keyup.enter="Login(3)"
                        ></el-input>
                      </el-col>
                      <el-col
                        :xs="8"
                        :sm="8"
                        :md="8"
                        :lg="8"
                        :xl="8"
                        class="ml15"
                      >
                        <span style="cursor: pointer">
                          <div
                            style="
                              height: 40px;
                              width: 110px;
                              font-size: 22px;
                              padding: 5px;
                            "
                            @click="initVeri()"
                            :style="'background-image:url(' + codeImg + ')'"
                            v-html="Picture"
                          ></div>
                        </span>
                      </el-col>
                      <div class="msg_error" style="width: 100%" v-show="yzhid">
                        {{ yzhid }}
                      </div>
                    </el-form-item>
                    <el-form-item label class="loginbtn" v-if="!isLoginCode">
                      <el-button type="primary" @click="Login(3)"
                        >Login</el-button
                      >
                    </el-form-item>
                    <el-form-item label class="loginbtn" v-else>
                      <el-button type="primary" @click="Login(3, 1)"
                        >Login</el-button
                      >
                    </el-form-item>
                  </div>
                  <template v-if="status == 1 && isLoginCode">
                    <div class="twenfive" style="margin-top: 0px">
                      <div class="highgreen">
                        The system has sent the verification code to{{
                          mobelEm
                        }},please find.
                      </div>
                    </div>
                    <el-form-item
                      label="Email V Code:"
                      :rules="[{ required: true }]"
                      style="margin-top: 15px"
                    >
                      <el-col :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.yzcodes"
                          placeholder="Please input Email V Code"
                        ></el-input>
                      </el-col>
                      <div class="clearfix"></div>
                      <div class="msg_error" v-html="yzcodesTiShi"></div>
                    </el-form-item>
                    <el-form-item label="">
                      <el-button
                        style="width: 48%"
                        type="primary"
                        @click="Login(1, 2)"
                        >Submit</el-button
                      >
                      <el-button
                        style="width: 48%"
                        class="ml1"
                        @click="$router.push('/')"
                        >Cancel</el-button
                      >
                    </el-form-item>
                  </template>
                  <el-form-item label class="login-check">
                    <div class="leftfloat login_pwd" style="margin-left: 3px">
                      <el-checkbox v-model="checked"
                        >Remember password</el-checkbox
                      >
                    </div>
                    <div class="rightfloat">
                      <a
                        class="highblue"
                        @click="$router.push('/LookforPassword')"
                        style="cursor: pointer"
                        >Retrieve password</a
                      >
                    </div>
                  </el-form-item>
                </el-form>
                <div class="clearfix"></div>
              </el-tab-pane>
            </el-tabs>
            <div class="clearfix"></div>
            <div class="login_other fifth">
              <p class="text-center">
                No account? &nbsp;<a
                  href="javascript:void(0)"
                  @click="$router.push('/regist')"
                  >Sign up now</a
                >
              </p>
              <p class="text-center">
                Log in using other methods&nbsp;&nbsp;<a
                  href="javascript:void(0)"
                  @click="$router.push('/')"
                  >Homepage</a
                >
              </p>
              <p class="text-center">
                QQ,WeChat can login directly，No registration required.
              </p>
              <div class="clearfix"></div>
              <div class="login_other_button">
                <el-button
                  v-if="isweixin"
                  text
                  @click="wxshow()"
                  class="weixin"
                  ><img src="../../assets/images/add_wx1.png"
                /></el-button>
                <el-dialog
                  v-model="dialogVisible"
                  width="30%"
                  center
                  :before-close="handleClose"
                >
                  <div v-loading="loading">
                    <p class="mobList eqcode">
                      Long press the identification QR code to register and log
                      in
                    </p>
                    <p class="pclist eqcode">
                      Please use wechat to scan QR code to register and log in
                    </p>
                    <div>
                      <img :src="src" width="150" height="150" style="" />
                    </div>
                  </div>
                </el-dialog>
                <a style="cursor: pointer" @click="useqqlogin" class="qq_login"
                  ><img src="../../assets/images/add_qq1.png"
                /></a>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MasterButtom></MasterButtom>
    <el-dialog
      v-model="pwdFalseShow"
      width="27%"
      class="errDia"
      :before-close="handleClose"
      title="hint"
    >
      <div style="text-align: center">
        <p>
          Your password does not meet relevant requirements,Please
          &nbsp;<router-link to="/ChangePassword" style="color: red"
            >click here</router-link
          >&nbsp; to change your password.
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../utils/gogocodeTransfer'
var timeStop
import md5 from 'js-md5'
import CryptoJS from 'crypto-js'
import Login_WeiXin from '../../components/Login/Login_WeiXin'
import MasterButtom from '../../components/MasterButtom'
import axios from '../../assets/config/axios.config'
const key = CryptoJS.enc.Utf8.parse('1234123412ABCDEF') //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('ABCDEF1234123412') //十六位十六进制数作为密钥偏移量
export default {
  name: 'login',
  data() {
    return {
      dialogVisible: false,
      loading: true,
      showWx: false,
      userhid: false,
      passhid: false,
      yzhid: false,
      isweixin: true,
      activeName: 'first',
      isphone: false,
      isphones: false,
      ismobe: false,
      pwdFalseShow: false,
      pwdTiShi: '',
      pwdErr: false,
      userTishi: '',
      src: '',
      carousel: '',
      Code: '',
      timeStop: '',
      form: {
        name: '',
        type: '',
        pass: '',
        user: '',
        yzcode: '',
        yzcodes: '',
      },
      checked: '',
      title: '',
      titlea: '',
      num: 1,
      roleName: '',
      Picture: '',
      codeImg: require('../../assets/images/timg.jpg'),
      GUID: '',
      wx: '',
      tab: 1,
      status: 0,
      isLoginCode: false,
      mobelEm: '',
      yzcodesTiShi: '',
    }
  },
  components: {
    Login_WeiXin,
    MasterButtom,
  },
  deactivated() {
    window.clearInterval(timeStop)
  },
  deactivated() {
    this.form = {
      name: '',
      type: '',
      pass: '',
      user: '',
      yzcode: '',
      yzcodes: '',
    }
  },
  async mounted() {
    this.initVeri()
    if (this.$route.query.Guid) {
      let data = {
        guid: this.$route.query.Guid,
      }
      let res = await this.$store.dispatch('_getMMDL', data)
      console.log(res.data)
      if (res.data.IsSuccess) {
        if (!res.data.Data.IsGo) {
          this.pwdFalseShow = true
          return
        }
        localStorage.setItem('userInfo', JSON.stringify(res.data.Data))
        window.location.href = res.data.Data.URL
      } else {
        this.$message({
          showClose: true,
          message: this.$CHEn.CH_EN(res.data.Message),
          type: 'success',
        })
        setTimeout(() => window.close(), 1000)
      }
    }
    if (this.$route.query.Login) {
      this.num = this.$route.query.Login
    } else {
      if (sessionStorage.getItem('Login')) {
        this.num = sessionStorage.getItem('Login')
      } else {
        this.num = 1
      }
    }

    let params = [
      1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 2960,
      6021, 6022, 310, 12,
    ]
    this.$store.dispatch('_getSet', params).then((res) => {
      sessionStorage.setItem('SetItem', JSON.stringify(res.data.Data))
      let SetItem = res.data.Data
      SetItem.map((item) => {
        if (item.SetItemID == 11) {
          if (item.Item_Value == '是') {
            this.isphone = true
          } else {
            this.isphone = false
          }
        }
        if (item.SetItemID == 2960) {
          if (item.Item_Value == '是') {
            this.isweixin = true
          } else {
            this.isweixin = false
          }
        }
        if (item.SetItemID == 6022) {
          if (item.Item_Value == '是') {
            this.isLoginCode = true
          } else {
            this.isLoginCode = false
          }
        }
        if (item.SetItemID == 12) {
          if (item.Item_Value == '是') {
            this.isphones = true
          } else {
            this.isphones = false
          }
        }
      })
    })

    if (localStorage.getItem('Logintype') == 'email') {
      this.tab = 2
      this.activeName = 'second'
    } else if (localStorage.getItem('Logintype') == 'phone') {
      this.tab = 3
      this.activeName = 'third'
    }
    if (this.num == '1') {
      this.title = 'Author Login'
      this.titlea = 'Author Login'
      this.roleName = 'Authors'
      if (this.tab == 1) {
        if (JSON.parse(localStorage.getItem('user_Authors_user'))) {
          this.checked = true
          this.form.user = JSON.parse(
            localStorage.getItem('user_Authors_user')
          ).name
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem('user_Authors_user')).pass
          )
        }
      } else if (this.tab == 2) {
        if (JSON.parse(localStorage.getItem('user_Authors_email'))) {
          this.checked = true
          this.form.user = JSON.parse(
            localStorage.getItem('user_Authors_email')
          ).name
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem('user_Authors_email')).pass
          )
        }
      } else {
        if (JSON.parse(localStorage.getItem('user_Authors_phone'))) {
          this.checked = true
          this.form.user = JSON.parse(
            localStorage.getItem('user_Authors_phone')
          ).name
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem('user_Authors_phone')).pass
          )
        }
      }
    } else if (this.num == '3') {
      this.title = 'Referee  Login'
      this.titlea = 'Referee  Login'
      this.roleName = 'Experts'
      if (this.tab == 1) {
        if (JSON.parse(localStorage.getItem('user_Experts_user'))) {
          this.checked = true
          this.form.user = JSON.parse(
            localStorage.getItem('user_Experts_user')
          ).name
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem('user_Experts_user')).pass
          )
        }
      } else if (this.tab == 2) {
        this.checked = true
        if (JSON.parse(localStorage.getItem('user_Experts_email'))) {
          this.form.user = JSON.parse(
            localStorage.getItem('user_Experts_email')
          ).name
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem('user_Experts_email')).pass
          )
        }
      } else {
        if (JSON.parse(localStorage.getItem('user_Experts_phone'))) {
          this.checked = true
          this.form.user = JSON.parse(
            localStorage.getItem('user_Experts_phone')
          ).name
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem('user_Experts_phone')).pass
          )
        }
      }
    } else if (this.num == '2') {
      this.title = 'Editor  Login'
      this.titlea = 'Editor  Login'
      this.roleName = 'Editors'
      if (this.tab == 1) {
        if (JSON.parse(localStorage.getItem('user_Editors_user'))) {
          this.checked = true
          this.form.user = JSON.parse(
            localStorage.getItem('user_Editors_user')
          ).name
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem('user_Editors_user')).pass
          )
        }
      } else if (this.tab == 2) {
        this.checked = true
        if (JSON.parse(localStorage.getItem('user_Editors_email'))) {
          this.form.user = JSON.parse(
            localStorage.getItem('user_Editors_email')
          ).name
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem('user_Editors_email')).pass
          )
        }
      } else {
        if (JSON.parse(localStorage.getItem('user_Editors_phone'))) {
          this.checked = true
          this.form.user = JSON.parse(
            localStorage.getItem('user_Editors_phone')
          ).name
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem('user_Editors_phone')).pass
          )
        }
      }
    }
  },
  methods: {
    oninput() {
      if (this.form.user == '') {
        this.form.pass = ''
      }
    },
    DetectInput(elem, type) {
      //焦点离开时候的事件
      if (elem.target.value != '') {
        this.passhid = ''
      }
      if (type == 'pws') {
        if (this.$Bai(elem.target.value)) {
          this.passhid = 'Please input password!'
          return
        } else if (this.$Space(elem.target.value)) {
          this.passhid = ''
          this.pwdErr = true
          return
        } else if (this.$base(elem.target.value, 'aff')) {
          this.passhid = ''
          this.pwdErr = true
          return
        } else if (!this.$base(elem.target.value, 'users')) {
          this.passhid = ''
          this.pwdErr = true
          return
        } else {
          this.pwdErr = false
          this.pwdTiShi = ''
        }
      }

      if (type == 'user') {
        if (this.$Bai(elem.target.value)) {
          this.userTishi = 'UserName cannot be empty'
        } else {
          this.userTishi = ''
        }
      }
    },

    handleQrcodeCheck(type) {
      var urldomain = ''
      timeStop = window.setInterval(() => {
        this.$store
          .dispatch('_getWeiXinLogin', { Scene: this.Code })
          .then((res) => {
            if (res.data.IsSuccess) {
              //判断权限
              var roleId = res.data.Data.RoleID.toString()
              console.log(type + roleId)
              if (type == 2 && roleId.indexOf('Editors') > 0) {
                this.$message({ message: 'Login succeeded', type: 'success' })
                localStorage.setItem('userInfo', JSON.stringify(res.data.Data))
                urldomain = '/editor/#/editor/Index'
              } else if (type == 3 && roleId.indexOf('Experts') > 0) {
                this.$message({ message: 'Login succeeded', type: 'success' })
                localStorage.setItem('userInfo', JSON.stringify(res.data.Data))
                urldomain = '/expert/#/examine-manuscripts'
              } else if (type == 1 && roleId.indexOf('Authors') != -1) {
                this.$message({ message: 'Login succeeded', type: 'success' })
                localStorage.setItem('userInfo', JSON.stringify(res.data.Data))
                urldomain = 'author/#/author-index'
              } else {
                this.$message({
                  showClose: true,
                  message: 'Login failed',
                  type: 'error',
                })
                urldomain = '/'
              }
              window.location.href = urldomain
              if (!res.data.Data.IsGo) {
                this.pwdFalseShow = true
                return
              }
            }
          })
      }, 2000)
    },
    //解密方法
    Decrypt(word) {
      let encryptedHexStr = CryptoJS.enc.Hex.parse(word)
      let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
      let decrypt = CryptoJS.AES.decrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      })
      let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
      return decryptedStr.toString()
    },
    //加密方法
    Encrypt(word) {
      let srcs = CryptoJS.enc.Utf8.parse(word)
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      })
      return encrypted.ciphertext.toString().toUpperCase()
    },
    async wxshow() {
      this.dialogVisible = true
      let carousel = await this.$store.dispatch('_getGetQrcode')
      if (carousel) {
        this.src = carousel.data.Url
        this.Code = carousel.data.Code
        this.loading = false
        this.handleQrcodeCheck(this.num)
        $emit(this, 'func', this.src)
      }
    },
    getMsgFormSon(data) {
      this.loading = false
      this.wx = data
    },
    dialoga(data) {
      this.dialogVisible = false
    },
    handleClick(tab, event) {
      this.tab = parseInt(tab.index) + 1
      this.form = {
        name: '',
        type: '',
        pass: '',
        user: '',
        yzcode: '',
        yzcodes: '',
      }
      this.userhid = false
      this.passhid = false
      this.yzhid = false
    },
    async Login(num, at) {
      var Type = ''
      var UserKey = ''
      this.userhid = ''
      this.passhid = ''
      this.yzhid = ''
      if (num == 1) {
        Type = 1 //用户登录
        if ((this.form.user == '') | null) {
          return (this.userhid = 'Username please')
        }
        // if (!this.$base(this.form.user,"user")){
        //   return this.userhid="您的用户名格式不正确"
        // }
      } else if (num == 2) {
        Type = 2 //邮箱登录
        if ((this.form.user == '') | null) {
          return (this.userhid = 'Email please')
        }
        if (!this.$base(this.form.user, 'email')) {
          return (this.userhid = 'Email format is incorrect')
        }
      } else {
        Type = 3 //手机号登录
        if ((this.form.user == '') | null) {
          return (this.userhid = 'Mobile number please')
        }
        if (!this.$base(this.form.user, 'phone')) {
          return (this.userhid = 'Mobile number format is incorrect')
        }
      }
      if ((this.form.pass == '') | null) {
        this.pwdFalseShow = false
        return (this.passhid = 'Password please')
      } else {
      }
      if (this.form.yzcode.length != 6) {
        return (this.yzhid = 'Not less than 6 characters')
      }
      if (this.$Space(this.form.pass)) {
        this.pwdFalseShow = true
        return
      } else if (this.$base(this.form.pass, 'aff')) {
        this.pwdFalseShow = true
        return
      } else if (!this.$base(this.form.pass, 'users')) {
        this.pwdFalseShow = true
        return
      } else {
        this.pwdFalseShow = false
      }
      if (at == 2) {
        if (this.form.yzcodes == '' || !this.form.yzcodes) {
          return (this.yzcodesTiShi =
            'Please enter the six-digit verification code received by email or mobile phone')
        }
      }
      //验证输入内容完毕  准备登录
      let pwm = md5(this.form.pass + '!@*Samson*@!')
      let pwaes = CryptoJS.AES.encrypt(this.form.pass, pwm).toString()
      let data = {
        Type,
        UserKey: this.form.user,
        pwm,
        pwaes,
        GUID: this.GUID,
        VCode: this.form.yzcode,
        roleName: this.roleName,
        Code: this.form.yzcodes,
      }
      let res = await this.$store.dispatch('_postLogin', data)
      this.initVeri()
      if (res.data.IsSuccess) {
        if (at == 1) {
          this.status = 1
          this.mobelEm = res.data.Message
          return
        }
        if (!res.data.Data.IsGo) {
          this.pwdFalseShow = true
          return
        }
        let user = {
          name: '',
          pass: '',
        }
        let loginData = {
          IsGo: res.data.Data.IsGo,
          GoPath: res.data.Data.GoPath,
        }

        localStorage.setItem('loginData', JSON.stringify(loginData))

        if (this.checked) {
          if (this.num == '1') {
            user.name = this.form.user
            user.pass = this.Encrypt(this.form.pass)
            if (Type == 1) {
              localStorage.setItem('user_Authors_user', JSON.stringify(user))
            } else if (Type == 3) {
              localStorage.setItem('user_Authors_phone', JSON.stringify(user))
            } else {
              localStorage.setItem('user_Authors_email', JSON.stringify(user))
            }
          } else if (this.num == '3') {
            //专家登录
            user.name = this.form.user
            user.pass = this.Encrypt(this.form.pass)
            if (Type == 1) {
              localStorage.setItem('user_Experts_user', JSON.stringify(user))
            } else if (Type == 3) {
              localStorage.setItem('user_Experts_phone', JSON.stringify(user))
            } else {
              localStorage.setItem('user_Experts_email', JSON.stringify(user))
            }
          } else if (this.num == '2') {
            user.name = this.form.user
            user.pass = this.Encrypt(this.form.pass)
            if (Type == 1) {
              localStorage.setItem('user_Editors_user', JSON.stringify(user))
            } else if (Type == 3) {
              localStorage.setItem('user_Editors_phone', JSON.stringify(user))
            } else {
              localStorage.setItem('user_Editors_email', JSON.stringify(user))
            }
          }
        } else {
          if (this.num == '1') {
            if (Type == 1) {
              localStorage.removeItem('user_Authors_user')
            } else if (Type == 3) {
              localStorage.removeItem('user_Authors_phone')
            } else {
              localStorage.removeItem('user_Authors_email')
            }
          } else if (this.num == '3') {
            //专家登录
            if (Type == 1) {
              localStorage.removeItem('user_Experts_user')
            } else if (Type == 3) {
              localStorage.removeItem('user_Experts_phone')
            } else {
              localStorage.removeItem('user_Experts_email')
            }
          } else if (this.num == '2') {
            if (Type == 1) {
              localStorage.removeItem('user_Editors_user')
            } else if (Type == 3) {
              localStorage.removeItem('user_Editors_phone')
            } else {
              localStorage.removeItem('user_Editors_email')
            }
          }
        }
        if (Type == 1) {
          localStorage.setItem('Logintype', 'user')
        } else if (Type == 3) {
          localStorage.setItem('Logintype', 'phone')
        } else {
          localStorage.setItem('Logintype', 'email')
        }

        this.$message({
          showClose: true,
          message: 'Login successful, jumping·······',
          type: 'success',
        })

        setTimeout(() => {
          if (this.num == 1) {
            localStorage.setItem('userInfo', JSON.stringify(res.data.Data))
            if (!res.data.Data.IsGo) {
              location.href = res.data.Data.GoPath + '?firstLogin=true'
              return
            }
            var urldomain = '/EN/author/#/'
            window.location.href = urldomain
            return
          } else if (this.num == 2) {
            localStorage.setItem('userInfo', JSON.stringify(res.data.Data))
            const hostname = document.location.hostname
            if (!res.data.Data.IsGo) {
              location.href = res.data.Data.GoPath + '?firstLogin=true'
              return
            }
            var urldomain = '/editor/#/editor/Index'
            window.location.href = urldomain
            return
          } else if (this.num == 3) {
            localStorage.setItem('userInfo', JSON.stringify(res.data.Data))
            const hostname = document.location.hostname
            if (!res.data.Data.IsGo) {
              location.href = res.data.Data.GoPath + '?firstLogin=true'
              return
            }
            var urldomain = '/EN/expert/#/examine-manuscripts'
            window.location.href = urldomain
            return
          }
        }, 1500)
      } else {
        this.$message({
          showClose: true,
          message: this.$CHEn.CH_EN(res.data.Message),
          type: 'error',
        })
      }
    },
    //页面初始化形成验证码以及GUID
    async initVeri() {
      var random_number = Math.floor(Math.random() * (100 + 1))
      let res = await this.$store.dispatch('_getVerificationcode', {
        GUID: '',
        random: random_number,
      })
      if (res.data.IsSuccess) {
        this.GUID = res.data.Data.GUID
        this.Picture = ''
        for (var i = 0; i < res.data.Data.Picture.split('').length; i++) {
          this.Picture +=
            '<span style="color:' +
            this.randomColor() +
            '">' +
            res.data.Data.Picture.split('')[i] +
            '</span>'
        }
      } else {
        alert('network error')
      }
    },
    //点击QQ登录
    // tz() {
    // 	var urldz = "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=101866331&response_type=token&scope=all&redirect_uri=http:/2020test.notefirst.com/login_qq";
    // 	window.location.href = urldz;
    // },
    useqqlogin() {
      // this.$router.push("/login_qq")
      // let redirect = "http://2020test.notefirst.com"
      // this.Openkind ="QQ"
      // QC.Login.showPopup({//打开QQ授权登录界面，授权成功后会重定向
      // appId:"101871016",
      // redirectURI:"http://2020test.notefirst.com/#/login_qq",//登录成功后会自动跳往该地址
      // });
      var urldz =
        'https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=' +
        window.OpenId +
        '&response_type=token&scope=all&redirect_uri=http%3A%2F%2F' +
        window.callBackHtp +
        '%2F%23%2Flogin_qq%3ftype=en'
      window.location.href = urldz
    },
    handleClose(done) {
      done()
      this.dialogVisible = false
      clearInterval(timeStop)
    },
    randomColor() {
      var col = 'rgb('
      for (var i = 0; i < 3; i++) {
        col += Math.floor(Math.random() * 256) + ','
      }
      col = col.slice(0, -1)
      col += ')'
      return col
    },
  },
  emits: ['func'],
}
</script>

<style scoped>
.eqcode {
  font-size: 16px;
}
.el-button--primary {
  width: 100% !important;
}
.loginbtn .el-button--primary {
  width: 100% !important;
}
</style>
